import { useQuery } from 'react-query';
import { getOffsiteTemplates } from './getOffsiteTemplates';
import { getOnsiteTemplates } from './getOnsiteTemplates';
import { TemplateType } from 'models/template/Template';

export const useGetTemplates = (
  siteId: string,
  options?: {
    filterBy?: TemplateType[];
    isDisplayOnlyEnabled?: boolean;
    showTemplatesValidForOffsiteOnly?: boolean;
  },
) => {
  return useQuery(['templates', siteId], async () => {
    let onsiteTemplates = await getOnsiteTemplates(siteId);
    let offsiteTemplates = await getOffsiteTemplates(siteId);

    onsiteTemplates = onsiteTemplates.filter(s => s.type !== TemplateType.MpsEmbed && s.type !== TemplateType.MpsPopup);

    if (!options?.isDisplayOnlyEnabled) {
      onsiteTemplates = onsiteTemplates.filter(s => s.type !== TemplateType.DisplayOnly);
    }

    if (options?.showTemplatesValidForOffsiteOnly) {
      onsiteTemplates = onsiteTemplates.filter(s => !s.isEmbedded || s.type !== TemplateType.DisplayOnly);
      offsiteTemplates = offsiteTemplates.filter(s => !s.isEmbedded || s.type !== TemplateType.DisplayOnly);
    }

    if (options?.filterBy) {
      onsiteTemplates = onsiteTemplates.filter(s => !options?.filterBy.indexOf(s.type));
      offsiteTemplates = offsiteTemplates.filter(s => !options?.filterBy.indexOf(s.type));
    }

    return [...onsiteTemplates, ...offsiteTemplates];
  });
};
